
export default function About() {
  return (
    <section id="about" className="py-32 bg-[#F8F7F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-4">
          <span className="text-xs uppercase tracking-wider text-gray-500 font-medium">About Us</span>
        </div>
        
        <div className="max-w-4xl ml-auto mb-20">
          <h2 className="text-5xl font-bold text-gray-900 leading-tight mb-8">
            A Team of Experts Developing Modern Applications
          </h2>
          <p className="text-gray-600 text-base leading-relaxed max-w-lg">
            Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices. We focus on creating intuitive, powerful solutions for iOS users worldwide.
          </p>
        </div>

        <div className="grid grid-cols-5 gap-6">
          <div className="col-span-2 rounded-2xl overflow-hidden shadow-lg h-96">
            <img 
              src="https://public.readdy.ai/ai/img_res/e02e05f08426f99d045719eb138b085b.jpg" 
              alt="Development Team" 
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="col-span-3 rounded-2xl overflow-hidden shadow-lg h-96">
            <img 
              src="https://readdy.ai/api/search-image?query=Modern%20iOS%20mobile%20application%20interface%20mockups%20displayed%20on%20multiple%20iPhone%20devices%20showing%20VPN%20and%20cleaner%20app%20screens%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20minimalist%20tech%20aesthetic&width=900&height=800&seq=sylpa-about-2&orientation=landscape" 
              alt="App Interfaces" 
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
